export default __webpack_public_path__ + "static/media/3-dot-icon.9311bc52.svg";